module.exports = __webpack_public_path__ + "static/img/parts-code.86f978da.png";